function testrating(a,b) {
    if(a == "Aries" && b == "Aries"){
        return 1
    }else if ((a == "Aries" && b=="Taurus") || (a =="Taurus" && b == "Aries" ) ){
        return 2
    }else if ((a == "Aries" && b=="Gemini") || (a =="Gemini" && b == "Aries" ) ){
        return 3
    }else if ((a == "Aries" && b=="Cancer") || (a =="Cancer" && b == "Aries" ) ){
        return 4
    }else if ((a == "Aries" && b=="Leo") || (a =="Leo" && b == "Aries" ) ){
        return 5
    }else if ((a == "Aries" && b=="Virgo") || (a =="Virgo" && b == "Aries" ) ){
        return 6
    }else if ((a == "Aries" && b=="Libra") || (a =="Libra" && b == "Aries" ) ){
        return 7
    }else if ((a == "Aries" && b=="Scorpio") || (a =="Scorpio" && b == "Aries" ) ){
        return 8
    }else if ((a == "Aries" && b=="Sagitarius") || (a =="Sagitarius" && b == "Aries" ) ){
        return 9
    }else if ((a == "Aries" && b=="Capricorn") || (a =="Capricorn" && b == "Aries" ) ){
        return 10
    }else if ((a == "Aries" && b=="Aquarius") || (a =="Aquarius" && b == "Aries" ) ){
        return 11
    }else if ((a == "Aries" && b=="Pisces") || (a =="Pisces" && b == "Aries" ) ){
        return 12
    }else if (a == "Taurus" && b=="Taurus"){
        return 13
    }else if ((a == "Taurus" && b=="Gemini") || (a =="Gemini" && b == "Taurus" ) ){
        return 14
    }else if ((a == "Taurus" && b=="Cancer") || (a =="Cancer" && b == "Taurus" ) ){
        return 15
    }else if ((a == "Taurus" && b=="Leo") || (a == "Leo" && b == "Taurus" ) ){
        return 16
    }else if ((a == "Taurus" && b=="Virgo") || (a =="Virgo" && b == "Taurus" ) ){
        return 17
    }else if ((a == "Taurus" && b=="Libra") || (a =="Libra" && b == "Taurus" ) ){
        return 18
    }else if ((a == "Taurus" && b=="Scorpio") || (a =="Scorpio" && b == "Taurus" ) ){
        return 19
    }else if ((a == "Taurus" && b=="Sagitarius") || (a =="Sagitarius" && b == "Taurus" ) ){
        return 20
    }else if ((a == "Taurus" && b=="Capricorn") || (a =="Capricorn" && b == "Taurus" ) ){
        return 21
    }else if ((a == "Taurus" && b=="Aquarius") || (a =="Aquarius" && b == "Taurus" ) ){
        return 22
    }else if ((a == "Taurus" && b=="Pisces") || (a =="Pisces" && b == "Taurus" ) ){
        return 23
    }else if (a == "Gemini" && b=="Gemini"){
        return 24
    }else if ((a == "Gemini" && b=="Cancer") || (a =="Cancer" && b == "Gemini" ) ){
        return 25
    }else if ((a == "Gemini" && b=="Leo") || (a =="Leo" && b == "Gemini" ) ){
        return 26
    }else if ((a == "Gemini" && b=="Virgo") || (a =="Virgo" && b == "Gemini" ) ){
        return 27
    }else if ((a == "Gemini" && b=="Libra") || (a =="Libra" && b == "Gemini" ) ){
        return 28
    }else if ((a == "Gemini" && b=="Scorpio") || (a =="Scorpio" && b == "Gemini" ) ){
        return 29
    }else if ((a == "Gemini" && b=="Sagitarius") || (a =="Sagitarius" && b == "Gemini" ) ){
        return 30
    }else if ((a == "Gemini" && b=="Capricorn") || (a =="Capricorn" && b == "Gemini" ) ){
        return 31
    }else if ((a == "Gemini" && b=="Aquarius") || (a =="Aquarius" && b == "Gemini" ) ){
        return 32
    }else if ((a == "Gemini" && b=="Pisces") || (a =="Pisces" && b == "Gemini" ) ){
        return 33
    }else if (a == "Cancer" && b=="Cancer"){
        return 34
    }else if ((a == "Cancer" && b=="Leo") || (a =="Leo" && b == "Cancer" ) ){
        return 35
    }else if ((a == "Cancer" && b=="Virgo") || (a =="Virgo" && b == "Cancer" ) ){
        return 36
    }else if ((a == "Cancer" && b=="Libra") || (a =="Libra" && b == "Cancer" ) ){
        return 37
    }else if ((a == "Cancer" && b=="Scorpio") || (a =="Scorpio" && b == "Cancer" ) ){
        return 38
    }else if ((a == "Cancer" && b=="Sagitarius") || (a =="Sagitarius" && b == "Cancer" ) ){
        return 39
    }else if ((a == "Cancer" && b=="Capricorn") || (a =="Capricorn" && b == "Cancer" ) ){
        return 40
    }else if ((a == "Cancer" && b=="Aquarius") || (a =="Aquarius" && b == "Cancer" ) ){
        return 41
    }else if ((a == "Cancer" && b=="Pisces") || (a =="Pisces" && b == "Cancer" ) ){
        return 42
    }else if (a == "Leo" && b=="Leo"){
        return 43
    }else if ((a == "Leo" && b=="Virgo") || (a =="Virgo" && b == "Leo" ) ){
        return 44
    }else if ((a == "Leo" && b=="Libra") || (a =="Libra" && b == "Leo" ) ){
        return 45
    }else if ((a == "Leo" && b=="Scorpio") || (a =="Scorpio" && b == "Leo" ) ){
        return 46
    }else if ((a == "Leo" && b=="Sagitarius") || (a =="Sagitarius" && b == "Leo" ) ){
        return 47
    }else if ((a == "Leo" && b=="Capricorn") || (a =="Capricorn" && b == "Leo" ) ){
        return 48
    }else if ((a == "Leo" && b=="Aquarius") || (a =="Aquarius" && b == "Leo" ) ){
        return 49
    }else if ((a == "Leo" && b=="Pisces") || (a =="Pisces" && b == "Leo" ) ){
        return 50
    }else if (a == "Virgo" && b=="Virgo"){
        return 51
    }else if ((a == "Virgo" && b=="Libra") || (a =="Libra" && b == "Virgo" ) ){
        return 52
    }else if ((a == "Virgo" && b=="Scorpio") || (a =="Scorpio" && b == "Virgo" ) ){
        return 53
    }else if ((a == "Virgo" && b=="Sagitarius") || (a =="Sagitarius" && b == "Virgo" ) ){
        return 54
    }else if ((a == "Virgo" && b=="Capricorn") || (a =="Capricorn" && b == "Virgo" ) ){
        return 55
    }else if ((a == "Virgo" && b=="Aquarius") || (a =="Aquarius" && b == "Virgo" ) ){
        return 56
    }else if ((a == "Virgo" && b=="Pisces") || (a =="Pisces" && b == "Virgo" ) ){
        return 57
    }else if (a == "Libra" && b=="Libra"){
        return 58
    }else if ((a == "Libra" && b=="Scorpio") || (a =="Scorpio" && b == "Libra" ) ){
        return 59
    }else if ((a == "Libra" && b=="Sagitarius") || (a =="Sagitarius" && b == "Libra" ) ){
        return 60
    }else if ((a == "Libra" && b=="Capricorn") || (a =="Capricorn" && b == "Libra" ) ){
        return 61
    }else if ((a == "Libra" && b=="Aquarius") || (a =="Aquarius" && b == "Libra" ) ){
        return 62
    }else if ((a == "Libra" && b=="Pisces") || (a =="Pisces" && b == "Libra" ) ){
        return 63
    }else if (a == "Scorpio" && b=="Scorpio"){
        return 64
    }else if ((a == "Scorpio" && b=="Sagitarius") || (a =="Sagitarius" && b == "Scorpio" ) ){
        return 65
    }else if ((a == "Scorpio" && b=="Capricorn") || (a =="Capricorn" && b == "Scorpio" ) ){
        return 66
    }else if ((a == "Scorpio" && b=="Aquarius") || (a =="Aquarius" && b == "Scorpio" ) ){
        return 67
    }else if ((a == "Scorpio" && b=="Pisces") || (a =="Pisces" && b == "Scorpio" ) ){
        return 68
    }else if (a == "Sagitarius" && b=="Sagitarius"){
        return 69
    }else if ((a == "Sagitarius" && b=="Capricorn") || (a =="Capricorn" && b == "Sagitarius" ) ){
        return 70
    }else if ((a == "Sagitarius" && b=="Aquarius") || (a =="Aquarius" && b == "Sagitarius" ) ){
        return 71
    }else if ((a == "Sagitarius" && b=="Pisces") || (a =="Pisces" && b == "Sagitarius" ) ){
        return 72
    }else if (a == "Capricorn" && b=="Capricorn"){
        return 73
    }else if ((a == "Capricorn" && b=="Aquarius") || (a =="Aquarius" && b == "Capricorn" ) ){
        return 74
    }else if ((a == "Capricorn" && b=="Pisces") || (a =="Pisces" && b == "Capricorn" ) ){
        return 75
    }else if (a == "Aquarius" && b=="Aquarius"){
        return 76
    }else if ((a == "Aquarius" && b=="Pisces") || (a =="Pisces" && b == "Aquarius" ) ){
        return 77
    }else if (a == "Pisces" && b=="Pisces"){
        return 78;
    }else if(a == "Rat" && b == "Rat"){
        return 1
     }else if ((a == "Rat" && b=="Ox") || (a =="Ox" && b == "Rat" ) ){
        return 2
     }else if ((a == "Rat" && b=="Tiger") || (a =="Tiger" && b == "Rat" ) ){
        return 3
     }else if ((a == "Rat" && b=="Rabbit") || (a =="Rabbit" && b == "Rat" ) ){
        return 4
     }else if ((a == "Rat" && b=="Dragon") || (a =="Dragon" && b == "Rat" ) ){
        return 5
     }else if ((a == "Rat" && b=="Snake") || (a =="Snake" && b == "Rat" ) ){
        return 6
     }else if ((a == "Rat" && b=="Horse") || (a =="Horse" && b == "Rat" ) ){
        return 7
     }else if ((a == "Rat" && b=="Goat") || (a =="Goat" && b == "Rat" ) ){
        return 8
     }else if ((a == "Rat" && b=="Monkey") || (a =="Monkey" && b == "Rat" ) ){
        return 9
     }else if ((a == "Rat" && b=="Rooster") || (a =="Rooster" && b == "Rat" ) ){
        return 10
     }else if ((a == "Rat" && b=="Dog") || (a =="Dog" && b == "Rat" ) ){
        return 11
     }else if ((a == "Rat" && b=="Pig") || (a =="Pig" && b == "Rat" ) ){
        return 12
     }else if (a == "Ox" && b=="Ox"){
        return 13
     }else if ((a == "Ox" && b=="Tiger") || (a =="Tiger" && b == "Ox" ) ){
        return 14
     }else if ((a == "Ox" && b=="Rabbit") || (a =="Rabbit" && b == "Ox" ) ){
        return 15
     }else if ((a == "Ox" && b=="Dragon") || (a == "Dragon" && b == "Ox" ) ){
        return 16
     }else if ((a == "Ox" && b=="Snake") || (a =="Snake" && b == "Ox" ) ){
        return 17
     }else if ((a == "Ox" && b=="Horse") || (a =="Horse" && b == "Ox" ) ){
        return 18
     }else if ((a == "Ox" && b=="Goat") || (a =="Goat" && b == "Ox" ) ){
        return 19
     }else if ((a == "Ox" && b=="Monkey") || (a =="Monkey" && b == "Ox" ) ){
        return 20
     }else if ((a == "Ox" && b=="Rooster") || (a =="Rooster" && b == "Ox" ) ){
        return 21
     }else if ((a == "Ox" && b=="Dog") || (a =="Dog" && b == "Ox" ) ){
        return 22
     }else if ((a == "Ox" && b=="Pig") || (a =="Pig" && b == "Ox" ) ){
        return 23
     }else if (a == "Tiger" && b=="Tiger"){
        return 24
     }else if ((a == "Tiger" && b=="Rabbit") || (a =="Rabbit" && b == "Tiger" ) ){
        return 25
     }else if ((a == "Tiger" && b=="Dragon") || (a =="Dragon" && b == "Tiger" ) ){
        return 26
     }else if ((a == "Tiger" && b=="Snake") || (a =="Snake" && b == "Tiger" ) ){
        return 27
     }else if ((a == "Tiger" && b=="Horse") || (a =="Horse" && b == "Tiger" ) ){
        return 28
     }else if ((a == "Tiger" && b=="Goat") || (a =="Goat" && b == "Tiger" ) ){
        return 29
     }else if ((a == "Tiger" && b=="Monkey") || (a =="Monkey" && b == "Tiger" ) ){
        return 30
     }else if ((a == "Tiger" && b=="Rooster") || (a =="Rooster" && b == "Tiger" ) ){
        return 31
     }else if ((a == "Tiger" && b=="Dog") || (a =="Dog" && b == "Tiger" ) ){
        return 32
     }else if ((a == "Tiger" && b=="Pig") || (a =="Pig" && b == "Tiger" ) ){
        return 33
     }else if (a == "Rabbit" && b=="Rabbit"){
        return 34
     }else if ((a == "Rabbit" && b=="Dragon") || (a =="Dragon" && b == "Rabbit" ) ){
        return 35
     }else if ((a == "Rabbit" && b=="Snake") || (a =="Snake" && b == "Rabbit" ) ){
        return 36
     }else if ((a == "Rabbit" && b=="Horse") || (a =="Horse" && b == "Rabbit" ) ){
        return 37
     }else if ((a == "Rabbit" && b=="Goat") || (a =="Goat" && b == "Rabbit" ) ){
        return 38
     }else if ((a == "Rabbit" && b=="Monkey") || (a =="Monkey" && b == "Rabbit" ) ){
        return 39
     }else if ((a == "Rabbit" && b=="Rooster") || (a =="Rooster" && b == "Rabbit" ) ){
        return 40
     }else if ((a == "Rabbit" && b=="Dog") || (a =="Dog" && b == "Rabbit" ) ){
        return 41
     }else if ((a == "Rabbit" && b=="Pig") || (a =="Pig" && b == "Rabbit" ) ){
        return 42
     }else if (a == "Dragon" && b=="Dragon"){
        return 43
     }else if ((a == "Dragon" && b=="Snake") || (a =="Snake" && b == "Dragon" ) ){
        return 44
     }else if ((a == "Dragon" && b=="Horse") || (a =="Horse" && b == "Dragon" ) ){
        return 45
     }else if ((a == "Dragon" && b=="Goat") || (a =="Goat" && b == "Dragon" ) ){
        return 46
     }else if ((a == "Dragon" && b=="Monkey") || (a =="Monkey" && b == "Dragon" ) ){
        return 47
     }else if ((a == "Dragon" && b=="Rooster") || (a =="Rooster" && b == "Dragon" ) ){
        return 48
     }else if ((a == "Dragon" && b=="Dog") || (a =="Dog" && b == "Dragon" ) ){
        return 49
     }else if ((a == "Dragon" && b=="Pig") || (a =="Pig" && b == "Dragon" ) ){
        return 50
     }else if (a == "Snake" && b=="Snake"){
        return 51
     }else if ((a == "Snake" && b=="Horse") || (a =="Horse" && b == "Snake" ) ){
        return 52
     }else if ((a == "Snake" && b=="Goat") || (a =="Goat" && b == "Snake" ) ){
        return 53
     }else if ((a == "Snake" && b=="Monkey") || (a =="Monkey" && b == "Snake" ) ){
        return 54
     }else if ((a == "Snake" && b=="Rooster") || (a =="Rooster" && b == "Snake" ) ){
        return 55
     }else if ((a == "Snake" && b=="Dog") || (a =="Dog" && b == "Snake" ) ){
        return 56
     }else if ((a == "Snake" && b=="Pig") || (a =="Pig" && b == "Snake" ) ){
        return 57
     }else if (a == "Horse" && b=="Horse"){
        return 58
     }else if ((a == "Horse" && b=="Goat") || (a =="Goat" && b == "Horse" ) ){
        return 59
     }else if ((a == "Horse" && b=="Monkey") || (a =="Monkey" && b == "Horse" ) ){
        return 60
     }else if ((a == "Horse" && b=="Rooster") || (a =="Rooster" && b == "Horse" ) ){
        return 61
     }else if ((a == "Horse" && b=="Dog") || (a =="Dog" && b == "Horse" ) ){
        return 62
     }else if ((a == "Horse" && b=="Pig") || (a =="Pig" && b == "Horse" ) ){
        return 63
     }else if (a == "Goat" && b=="Goat"){
        return 64
     }else if ((a == "Goat" && b=="Monkey") || (a =="Monkey" && b == "Goat" ) ){
        return 65
     }else if ((a == "Goat" && b=="Rooster") || (a =="Rooster" && b == "Goat" ) ){
        return 66
     }else if ((a == "Goat" && b=="Dog") || (a =="Dog" && b == "Goat" ) ){
        return 67
     }else if ((a == "Goat" && b=="Pig") || (a =="Pig" && b == "Goat" ) ){
        return 68
     }else if (a == "Monkey" && b=="Monkey"){
        return 69
     }else if ((a == "Monkey" && b=="Rooster") || (a =="Rooster" && b == "Monkey" ) ){
        return 70
     }else if ((a == "Monkey" && b=="Dog") || (a =="Dog" && b == "Monkey" ) ){
        return 71
     }else if ((a == "Monkey" && b=="Pig") || (a =="Pig" && b == "Monkey" ) ){
        return 72
     }else if (a == "Rooster" && b=="Rooster"){
        return 73
     }else if ((a == "Rooster" && b=="Dog") || (a =="Dog" && b == "Rooster" ) ){
        return 74
     }else if ((a == "Rooster" && b=="Pig") || (a =="Pig" && b == "Rooster" ) ){
        return 75
     }else if (a == "Dog" && b=="Dog"){
        return 76
     }else if ((a == "Dog" && b=="Pig") || (a =="Pig" && b == "Dog" ) ){
        return 77
     }else if (a == "Pig" && b=="Pig"){
        return 78;
     }

}

export default testrating;